import * as React from 'react'

import getConfig from 'next/config'

import { CmsComponentSlot, CmsHeadTags, useBloomreachPageRoutes } from '@grandvisionhq/bloomreach'
import { NextPage } from '@grandvisionhq/next'
import { ReviewsProvider, ReviewWrite } from '@grandvisionhq/reviews'
import { useFeatureToggles } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

import '@grandvisionhq/reviews/dist/index.css'

const { publicRuntimeConfig } = getConfig()
const selfUrl = publicRuntimeConfig.selfUrl || ''
const { apiKey: powerReviewsApiKey, groupId, opcoId } = publicRuntimeConfig.powerReviews

type ReviewProviderProps = React.ComponentProps<typeof ReviewsProvider>

const WriteReviewPage: NextPage = () => {
  const { routes } = useBloomreachPageRoutes()
  const { isReviewsEnabled } = useFeatureToggles()
  const reviewsProviderProps = React.useMemo<ReviewProviderProps>(
    () => ({
      enabled: isReviewsEnabled,
      config: {
        groupId,
        opcoId,
        apiKey: powerReviewsApiKey,
        writeReviewPath: routes['write-review'],
      },
    }),
    // other fields are static during runtime
    [routes]
  )

  return (
    <>
      <CmsHeadTags>
        {isReviewsEnabled && <link rel="preconnect" href="https://ui.powerreviews.com" />}
      </CmsHeadTags>
      <CmsComponentSlot path="main/top-container" />
      <ReviewsProvider {...reviewsProviderProps}>
        <ReviewWrite selfUrl={selfUrl} />
      </ReviewsProvider>
      <CmsComponentSlot path="main/bottom-container" />
    </>
  )
}

export default compose(withCms(), withLayout())(WriteReviewPage)
